module.exports={
	"Form": "MaterialEditManifest",
	"Scope": "Material-Edit",
	"Descriptors":
	{
		"MaterialDetails.Name":
		{
			"Name": "Name",
			"Hash": "Material-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Material-Edit-Identity",
				"Group": "Material-Edit-Identity"
			}
		},
		"MaterialDetails.NameAbbreviated":
		{
			"Name": "Name Abbreviated",
			"Hash": "Material-Edit-NameAbbreviated",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "Material-Edit-Identity",
				"Group": "Material-Edit-Identity"
			}
		},
		"MaterialDetails.CatalogCode":
		{
			"Name": "Catalog Code",
			"Hash": "Material-Edit-CatalogCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Material-Edit-Identity",
				"Group": "Material-Edit-Identity"
			}
		},
		"MaterialDetails.MaterialCode":
		{
			"Name": "Material Code",
			"Hash": "Material-Edit-MaterialCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Material-Edit-Identity",
				"Group": "Material-Edit-Identity"
			}
		},
		"MaterialDetails.ItemCode":
		{
			"Name": "Item Code",
			"Hash": "Material-Edit-ItemCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Material-Edit-Identity",
				"Group": "Material-Edit-Identity"
			}
		},
		"MaterialDetails.Type":
		{
			"Name": "Type",
			"Hash": "Material-Edit-Type",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "Material-Edit-Details",
				"Group": "Material-Edit-Details"
			}
		},
		"MaterialDetails.Description":
		{
			"Name": "Description",
			"Hash": "Material-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "4",
				"Width": 12,
				"Section": "Material-Edit-Details",
				"Group": "Material-Edit-Details"
			}
		},
		"MaterialDetails.UnitsMetric":
		{
			"Name": "Units Metric",
			"Hash": "Material-Edit-UnitsMetric",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "Material-Edit-Details",
				"Group": "Material-Edit-Details"
			}
		},
		"MaterialDetails.UnitsImperial":
		{
			"Name": "Units Imperial",
			"Hash": "Material-Edit-UnitsImperial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "Material-Edit-Details",
				"Group": "Material-Edit-Details"
			}
		},
		"MaterialDetails.Active":
		{
			"Name": "Active",
			"Hash": "Material-Edit-Active",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "5",
				"Width": 3,
				"Section": "Material-Edit-Details",
				"Group": "Material-Edit-Details"
			}
		},
		"MaterialDetails.BrandNameRequired":
		{
			"Name": "Brand Name Required",
			"Hash": "Material-Edit-BrandNameRequired",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "6",
				"Width": 3,
				"Section": "Material-Edit-Details",
				"Group": "Material-Edit-Details"
			}
		},
		"MaterialDetails.IDMaterialParent":
		{
			"Name": "Parent Material",
			"Hash": "Material-Edit-IDMaterialParent",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "6",
				"Width": 4,
				"Section": "Material-Edit-Details",
				"Group": "Material-Edit-Details",
				"Entity": "Material",
				"SearchFields":
				[
					"Name",
					"MaterialCode",
					"ItemCode"
				]
			}
		},
		"MaterialDetails.Category":
		{
			"Name": "Category",
			"Hash": "Material-Edit-Category",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "Material-Edit-Details",
				"Group": "Material-Edit-Details"
			}
		},
		"MaterialDetails.CategoryName":
		{
			"Name": "Category Name",
			"Hash": "Material-Edit-CategoryName",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "7",
				"Width": 4,
				"Section": "Material-Edit-Details",
				"Group": "Material-Edit-Details"
			}
		},
		"MaterialDetails.ItemSection":
		{
			"Name": "Item Section",
			"Hash": "Material-Edit-ItemSection",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "7",
				"Width": 4,
				"Section": "Material-Edit-Details",
				"Group": "Material-Edit-Details"
			}
		},
		"MaterialDetails.IDMaterial":
		{
			"Name": "IDMaterial",
			"Hash": "Material-Edit-IDMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Material-Edit-DataAudit",
				"Group": "Material-Edit-DataAudit"
			}
		},
		"MaterialDetails.GUIDMaterial":
		{
			"Name": "GUIDMaterial",
			"Hash": "Material-Edit-GUIDMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Material-Edit-DataAudit",
				"Group": "Material-Edit-DataAudit"
			}
		},
		"MaterialDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Material-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "8",
				"Width": 4,
				"Section": "Material-Edit-DataAudit",
				"Group": "Material-Edit-DataAudit"
			}
		},
		"MaterialDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Material-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "Material-Edit-DataAudit",
				"Group": "Material-Edit-DataAudit"
			}
		},
		"MaterialDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Material-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "Material-Edit-DataAudit",
				"Group": "Material-Edit-DataAudit"
			}
		},
		"MaterialDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Material-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "9",
				"Width": 4,
				"Section": "Material-Edit-DataAudit",
				"Group": "Material-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Material-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Material-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Material-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Material-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Material-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Material-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
